import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './BuildingInformation.scss';
import { Input } from 'reactstrap';

import { setBuildingInformation } from '../../actions';

import {
  InputWithTextBox,
  Tooltip,
  validateNumber,
  validateTextAndNumber,
  validateTextAndSpecialCharacter,
  validateNumberAndSpecialCharacter,
  HeaderSection,
} from '../../helpers';

class BuildingInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'buildingRefNo': '',
      'buildingName': '',
      'buildingCompanyName': '',
      'buildingTaxID': '',
      'buildingPOSID': '',
      'buildingAddress': '',
      'buildingContactName': '',
      'buildingContactNumber': '',
      'buildingEmergencyContactNumber': '',
      'buildingContactEmail': '',
      'buildingMerchantID': '',
      'buildingDashboardURL': '',
      'buildingVatRatePercentage': '',
      'isCanSave': false,
    };
  }

  componentDidMount() {
    this.dataFillInput();
  }

  dataFillInput() {
    const { buildingInformation } = this.props;

    if (buildingInformation) {
      this.setState({
        'buildingRefNo': buildingInformation.buildingRefNo ,
        'buildingName': buildingInformation.buildingName,
        'buildingCompanyName': buildingInformation.buildingCompanyName,
        'buildingTaxID': buildingInformation.buildingTaxID,
        'buildingPOSID': buildingInformation.buildingPOSID,
        'buildingAddress': buildingInformation.buildingAddress,
        'buildingContactName': buildingInformation.buildingContactName,
        'buildingContactNumber': buildingInformation.buildingContactNumber,
        'buildingContactEmail': buildingInformation.buildingContactEmail, 
        'buildingMerchantID': buildingInformation.buildingMerchantID,
        'buildingDashboardURL': buildingInformation.buildingDashboardURL ? buildingInformation.buildingDashboardURL : '',
        'buildingVatRatePercentage': buildingInformation.buildingVatRatePercentage ,
        'buildingEmergencyContactNumber' : buildingInformation.buildingEmergencyContactNumber,
      }, () => {
        if (this.handleCheckIsCanSave()) {        
          this.props.dispatch(setBuildingInformation({ 
            ...this.props.buildingInformation,
            'isCanSave': true,
          }));
        } else {
          this.props.dispatch(setBuildingInformation({ 
            ...this.props.buildingInformation,
            'isCanSave': false,
          }));
        }
      });
    }
  }

  handleCheckIsCanSave = () => {
    const {
      buildingRefNo,
      buildingName,
      buildingCompanyName,
      buildingTaxID,
      buildingPOSID,
      buildingAddress,
      buildingContactName,
      buildingContactNumber,
      buildingEmergencyContactNumber,
      buildingContactEmail,
      buildingMerchantID,        
      buildingVatRatePercentage,
    } = this.state;

    if (buildingRefNo !== '' && buildingName !== '' && buildingCompanyName !== '' 
    && buildingTaxID !== '' && buildingPOSID !== '' && buildingAddress !== '' 
    && buildingContactName !== '' && buildingContactNumber !== '' && buildingEmergencyContactNumber !== '' 
    && buildingContactEmail !== '' && buildingMerchantID !== '' && buildingVatRatePercentage !== '') {
      return true;
    } else {
      return false;
    }
  }

    handleDispatchData = () => {
      const {
        buildingRefNo,
        buildingName,
        buildingCompanyName,
        buildingTaxID,
        buildingPOSID,
        buildingAddress,
        buildingContactName,
        buildingContactNumber,
        buildingEmergencyContactNumber,
        buildingContactEmail,
        buildingMerchantID,        
        buildingVatRatePercentage,
        buildingDashboardURL,
      } = this.state;

      if (this.handleCheckIsCanSave()) {
        this.props.dispatch(setBuildingInformation({ 
          'buildingRefNo' : buildingRefNo,
          'buildingName' : buildingName,
          'buildingCompanyName' : buildingCompanyName,
          'buildingTaxID' : buildingTaxID,
          'buildingPOSID' : buildingPOSID,
          'buildingAddress' : buildingAddress,
          'buildingContactName' : buildingContactName,
          'buildingContactNumber' : buildingContactNumber,
          'buildingEmergencyContactNumber' : buildingEmergencyContactNumber,
          'buildingContactEmail' : buildingContactEmail,
          'buildingMerchantID': buildingMerchantID,
          'buildingVatRatePercentage' : buildingVatRatePercentage != '' ? parseInt(buildingVatRatePercentage) : 0,
          'buildingDashboardURL' : buildingDashboardURL,
          'isCanSave': true, 
        }));
      } else {
        this.props.dispatch(setBuildingInformation({ 
          'buildingRefNo' : buildingRefNo,
          'buildingName' : buildingName,
          'buildingCompanyName' : buildingCompanyName,
          'buildingTaxID' : buildingTaxID,
          'buildingPOSID' : buildingPOSID,
          'buildingAddress' : buildingAddress,
          'buildingContactName' : buildingContactName,
          'buildingContactNumber' : buildingContactNumber,
          'buildingEmergencyContactNumber' : buildingEmergencyContactNumber,
          'buildingContactEmail' : buildingContactEmail,
          'buildingMerchantID': buildingMerchantID,
          'buildingVatRatePercentage' : buildingVatRatePercentage != '' ? parseInt(buildingVatRatePercentage) : 0,
          'buildingDashboardURL' : buildingDashboardURL,
          'isCanSave': false, 
        }));
      }
    }
 
    handleEvent = (key, value) => {
      this.setState({ [key]: value }, () => { this.handleDispatchData();});
    }

    render() {
      const {
        buildingRefNo,
        buildingName,
        buildingCompanyName,
        buildingTaxID,
        buildingPOSID,
        buildingAddress,
        buildingContactName,
        buildingContactNumber,
        buildingEmergencyContactNumber,
        buildingContactEmail,
        buildingMerchantID,
        buildingDashboardURL,
        buildingVatRatePercentage,
      } = this.state;

      return (
        <div className="BuildingInformation">
          <HeaderSection title="Building information" isHeader={true} />
          <div className="screen-box">
            <div className="row-items">
              <div className="box-item">
                <div className="title-input">Building number</div>
                <Input
                  id="building-number-input"
                  className={'template-d'}
                  placeholder="Input building number"
                  value={buildingRefNo}
                  disabled={this.props.disabledBuildingRefNo}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (validateNumber(value) && value.length <= 4) {
                      this.handleEvent('buildingRefNo', value);
                    }
                  }}
                  maxLength={4}
                />
              </div>
              <div className="box-item">
                <div className="title-input">Building name</div>
                <Input
                  id="building-name-input"
                  className={'template-d'}
                  placeholder="Input building name"
                  value={buildingName}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value.length <= 50) {
                      this.handleEvent('buildingName', value);
                    }
                  }}
                  maxLength={50}
                />
              </div>
            </div>
            <div className="row-items">
              <div className="box-item">
                <div className="title-input">Company name</div>
                <Input
                  id="building-company-name"
                  className={'template-d'}
                  placeholder="Input company name"
                  value={buildingCompanyName}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value.length <= 50) {
                      this.handleEvent('buildingCompanyName', value);
                    }
                  }}
                  maxLength={50}
                />
              </div>
              <div className="box-item">
                <div className="title-input">Tax ID</div>
                <Input
                  id="building-tax-id"
                  className={'template-d'}
                  placeholder="Input tax ID"
                  value={buildingTaxID}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (validateNumber(value) && value.length <= 13) {
                      this.handleEvent('buildingTaxID', value);
                    }
                  }}
                  maxLength={13}
                />
              </div>
            </div>
            <div className="row-items">
              <div className="box-item">
                <div className="title-input">
                  <Tooltip tooltip="หมายเลขเครื่องบันทึกเงินสดที่ได้รับมาจากกรมสรรพากร">
                                    Pos ID
                  </Tooltip>
                </div>
                <Input
                  id="building-pos-id"
                  className={'template-d'}
                  placeholder="Input pos ID"
                  value={buildingPOSID}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (validateTextAndNumber(value) && value.length <= 15) {
                      this.handleEvent('buildingPOSID', value);
                    }
                  }}
                  maxLength={15}
                />
              </div>
              <div className="box-item">
                <div className="title-input">Building address</div>
                <Input
                  id="building-building-address"
                  className={'template-d'}
                  placeholder="Input building address"
                  value={buildingAddress}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value.length <= 50) {
                      this.handleEvent('buildingAddress', value);
                    }
                  }}
                  maxLength={50}
                />
              </div>
            </div>
            <div className="row-items">
              <div className="box-item">
                <div className="title-input">Contact name</div>
                <Input
                  id="building-contact-name"
                  className={'template-d'}
                  placeholder="Input contact name"
                  value={buildingContactName}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (validateTextAndSpecialCharacter(value) && value.length <= 50) {
                      this.handleEvent('buildingContactName', value);
                    }
                  }}
                  maxLength={50}
                />
              </div>
              <div className="box-item">
                <div className="title-input">Contact number</div>
                <Input
                  id="building-contact-number"
                  className={'template-d'}
                  placeholder="Input contact number"
                  value={buildingContactNumber}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (validateNumberAndSpecialCharacter(value) && value.length <= 10) {
                      this.handleEvent('buildingContactNumber', value);
                    }
                  }}
                  maxLength={10}
                />
              </div>
            </div>
            <div className="row-items">
              <div className="box-item">
                <div className="title-input">
                  <Tooltip tooltip="เบอร์โทรติดต่อฉุกเฉิน ที่จะแสดงอยู่บนหน้าจอทางเข้าออก">
                                    Emergency Contact number
                  </Tooltip>
                </div>
                <Input
                  id="building-emergency-contact-number"
                  className={'template-d'}
                  placeholder="Input emergency contact number"
                  value={buildingEmergencyContactNumber}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (validateNumberAndSpecialCharacter(value) && value.length <= 10) {
                      this.handleEvent('buildingEmergencyContactNumber', value);
                    }
                  }}
                  maxLength={10}
                />
              </div>
              <div className="box-item">
                <div className="title-input">Contact email</div>
                <Input
                  id="building-contact-email"
                  className={'template-d'}
                  placeholder="Input contact email"
                  value={buildingContactEmail}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value.length <= 50) {
                      this.handleEvent('buildingContactEmail', value);
                    }
                  }}
                  maxLength={50}
                />
              </div>
            </div>
            <div className="row-items">
              <div className="box-item">
                <div className="title-input">
                  <Tooltip tooltip="หมายเลขร้านค้าที่กำหนดโดย Kbank">
                                    Bank merchant ID
                  </Tooltip>
                </div>
                <Input
                  id="building-bank-merchant-id"
                  className={'template-d'}
                  placeholder="Input bank merchant ID"
                  value={buildingMerchantID}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (validateTextAndNumber(value) && value.length <= 20) {
                      this.handleEvent('buildingMerchantID', value);
                    }
                  }}
                  maxLength={20}
                />
              </div>
              <div className="box-item">
                <div className="title-input">
                  <Tooltip tooltip="สิงค์แสดงผล Executive dashboard">
                                    Dashboard URL (optional)
                  </Tooltip>
                </div>
                <Input
                  id="building-dashboard-url"
                  className={'template-d'}
                  placeholder="URL"
                  value={buildingDashboardURL}
                  onChange={(event) => {
                    const value = event.target.value;
                    this.handleEvent('buildingDashboardURL', value);
                  }}
                />
              </div>
            </div>
            <div className="row-items">
              <div className="box-item">
                <div className="title-input">Vat percentage</div>
                <InputWithTextBox
                  id="building-vat-percentage"
                  template="a"
                  value={buildingVatRatePercentage.toString()}
                  placeholder="Input Vat between 0 - 100"
                  onChange={(event) => {
                    const value = event.target.value;
                    if (validateNumber(value) && value.length <= 3) {
                      this.handleEvent('buildingVatRatePercentage', value);
                    }
                  }}
                  text="%"
                  maxLength={3}
                />
              </div>
              <div className="box-item"></div>
            </div>
          </div>
        </div>
      );
    }
}

BuildingInformation.propTypes = {
  'buildingInformation': PropTypes.shape({
    'data': PropTypes.any,
  }),
};

const mapStateToProps = ({ buildingInformation }) => ({
  'buildingInformation': buildingInformation.data,
});

export default connect(mapStateToProps)(BuildingInformation);

BuildingInformation.propTypes = {
  'dispatch' : PropTypes.func,
  'disabledBuildingRefNo' : PropTypes.bool,
  'buildingInformation' : PropTypes.shape({
    'buildingRefNo': PropTypes.string,
    'buildingName': PropTypes.string,
    'buildingCompanyName': PropTypes.string,
    'buildingTaxID': PropTypes.string,
    'buildingPOSID': PropTypes.string,
    'buildingAddress': PropTypes.string,
    'buildingContactName': PropTypes.string,
    'buildingContactNumber': PropTypes.string,
    'buildingEmergencyContactNumber': PropTypes.string,
    'buildingContactEmail': PropTypes.string,
    'buildingMerchantID': PropTypes.string,
    'buildingDashboardURL': PropTypes.string,
    'buildingVatRatePercentage': PropTypes.number,
  }),
};
